import { useMemo } from 'react';

export function useOperatorsBuildTable(inputs, t) {
  const headCells = useMemo(() => {
    return [{ id: 'name', numeric: false, disablePadding: false, label: t('properties.name'), ellipsis: true }];
  }, [t]);

  const rows = useMemo(() => {
    if (!inputs) {
      return [];
    }
    return inputs.items.map(operator => ({
      name: operator.name,
      canBeDeleted: !operator.hasRequests,
      id: operator.id
    }));
  }, [inputs]);

  return { headCells, rows };
}
